import React, { useState, useRef, useEffect } from "react";
import { styled } from "../../stitches.config";
import Cookies from "cookies-js"
// import { mainColor } from '../../stitches.config.ts';

import Media from "./Media";
import Link from "../Link";
import ArticleLinks from "./ArticleLinks";
// import CircleButton from '../CircleButton'
import SwitchText from './SwitchText'

import { bridVote } from './bridVote'


const BridTileSmall2 = props => {
  const [imageHeight, setHeight] = useState(200);
  const pictureContainer = useRef(null);

  const { article, secondArticleID, thirdArticleID, disableVote, voted, percentage, uID, hasCookie, votingResult, media } = props;
  const articlesGroup = [article.articleID, secondArticleID, thirdArticleID]
  const titleConditionalPadding = disableVote ? '50px;' : '0';
  var imgUrl = article.picture.img;

  useEffect(() => {
    if (pictureContainer?.current?.clientWidth) {
      const eltWidth = pictureContainer?.current?.clientWidth;
      const cHeight = Math.ceil(eltWidth * 2 / 3);

      if (cHeight !== imageHeight) {
        setHeight(cHeight);
      }

      // console.log('cHeight', height, cHeight, media);
    }
  }, []);

  const fetchVotes = async () => {
    const votes = await bridVote(article.articleID, articlesGroup)
      .catch(err => console.log(err))

    if (votes) {
      props.setPercentage(votes.data?.articlesAverage);
      props.setVoted(article.articleID);
      if (uID) Cookies.set('_brid', `${props.uID}.${article.articleID}`, { expires: 86400 })
    }
  }

  return (
    <BoxWrapper imageHeight={imageHeight} preserveImageRatio={props.preserveImageRatio}>
      <WithLink
        condition={!!disableVote}
        wrapper={children => <Link to={article.url}>{children}</Link>}
      >
        <ImageWrapper ref={pictureContainer} imageHeight={imageHeight} preserveImageRatio={props.preserveImageRatio}>
          <Overlay>
            <Media
              media={media}
              src={imgUrl}
              preserveRatio={false}
              aspectRatio={1.5}
              height={imageHeight}
            />
          </Overlay>
          <ArticleID>{props.id.replace('b', '0')}</ArticleID>
        </ImageWrapper>
      </WithLink>

      <Footer className={article.show_links && article.show_links != 'off' ? 'show-links' : null} size={props.size}>
        <WithLink
          condition={!!disableVote}
          wrapper={children => <Link to={article.url}>{children}</Link>}
        >
          <Title className="text-on-picture__title"
            css={{
              "$$padding": titleConditionalPadding + 'px',
              "$$size": props.size
            }}
          >
            {article.title}
          </Title>
        </WithLink>
        {!!disableVote ||
          <React.Fragment>
            {
              hasCookie
                ? <Thankyou>{votingResult[article.articleID]}% głosów</Thankyou>
                : <>
                  {voted === null ?
                    <Button
                      onClick={fetchVotes}>
                      Oddaj głos na temat
                    </Button> : <SwitchText
                      firstText={voted === article.articleID && 'Dziękujemy za oddany głos!'}
                      secondText={`${percentage[article.articleID]}% głosów`}
                      render={data => (<Thankyou>{data}</Thankyou>)}
                    />}
                </>
            }
          </React.Fragment>}
      </Footer>
    </BoxWrapper>
  );
};

const WithLink = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children)


const Button = styled("button", {
  padding: "12px",
  width: "100%",
  backgroundColor: "#FF6400",
  border: "none",
  color: "#fff",
  fontWeight: 600
});
const Overlay = styled("div", {
  overflow: "hidden",
  "& > img": {
    position: "relative"
  }
});
const Thankyou = styled("div", {
  padding: "12px",
  width: "100%",
  backgroundColor: "#FF6400",
  border: "none",
  color: "#fff",
  fontWeight: 600,
  textAlign: "center",
  height: "44px"
});

const Title = styled("span", {
  display: "block",
  position: "relative",
  pointerEvents: "none",
  width: "87%",
  marginBottom: "16px",
  fontSize: "18px",
  fontWeight: 600,
  color: "#131212",
  paddingBottom: "$$padding",
  "@bp4": {
    width: "232px",
    minHeight: "40px",
    marginBottom: "0px"
  }
});

const BoxWrapper = styled("div", {
  border: "1px solid transparent",
  background: "white",
  position: "relative",
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  backgroundSize: "cover",
  "> a": {
    display: "block",
    textDecoration: "none",
    position: "absolute",
    zIndex: 1,
    left: "0",
    right: "0",
    top: "0",
    bottom: "50px",
    minWidth: "100%",
    "@bp4": {
      position: "absolute"
    }
  },
  "@bp4": {
    maxHeight: "394px",
    margin: "10px 0",
    border: "1px solid transparent"
  },
  variants: {
    "preserveImageRatio": {
      true: {
        "& > a": {
          "@bp4": {
            position: "static"
          }
        }
      },
      false: {}
    }
  }
});

const ImageWrapper = styled("span", {
  width: "100%",
  backgroundColor: "#666",
  position: "relative",
  overflow: "hidden",
  "@bp4": {
    display: "block",
    ".preserveImageRatioImage": {
      width: "100%"
    }
  }
});
const ArticleID = styled("div", {
  position: "absolute",
  top: "0",
  left: "0",
  width: "40px",
  height: "40px",
  backgroundColor: "#131212",
  color: "#fff",
  textAlign: "center",
  lineHeight: "40px",
  zIndex: 10,
  fontSize: "18px",
  fontWeight: 700,
  letterSpacing: "0.2px"
});

const Footer = styled("span", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignSelf: "flex-start",
  width: "100%",
  zIndex: 3,
  marginTop: "16px",
  "@bp4": [
    {
      height: "176px"
    },
    {
      [`& ${Title}`]: {
        maxWidth: "113%"
      },
      "&.show-links": {
        paddingLeft: "250px"
      }
    }
  ],
  a: {
    textDecoration: "none"
  },
  [`& ${Title}`]: {
    right: "0"
  }
});

export default BridTileSmall2;
